module.exports = __webpack_public_path__ + "static/media/chrome-mobile-step-1.22f4171a.png";